export default __webpack_public_path__ + "static/media/Prospective.ffaad66f.png";